.label {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-70);
  line-height: var(--line-heights-100);
  color: var(--colors-text-tertiary);
}
